import PersonalizationApi from "@/features/triangle-rewards/api/PersonalizationApi";

const state = {
    token: null,
    loadedOneToOneOffers : []
}

const getters = {
    offersPage(state, getters, rootState) {
        return rootState.pages.find((page) => {
            return page.id === 'offersPage';
        })
    },
    hasOneToOneOffers(state) {
        return !!state.loadedOneToOneOffers;
    },
    offers(state) {
        if(state.loadedOneToOneOffers) return state.loadedOneToOneOffers;
        return [];
    },
    canViewOneToOneOffers(state, getters, rootState, rootGetters) {
        return rootGetters["ctUser/isSignedIn"] && rootGetters["ctUser/hasTriangleID"];
    },
}

const actions = {
    async fetchToken({commit}){
      let token = localStorage.getItem('token');
      const tokenExpiry = localStorage.getItem('tokenExpiry')

        //Check if token exists & is not expired
        if(token && tokenExpiry && new Date().getTime() < tokenExpiry){
            commit('SET_TOKEN',token)
            return token;
        }

        try{
            const response = await PersonalizationApi.fetchToken();
            token = response.accessToken;

            //Store token with expiry time of 1 hour (3599s)
            const expiryTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour;
            localStorage.setItem('token',token)
            localStorage.setItem('tokenExpiry',expiryTime)

            commit('SET_TOKEN',token)
            return token;
        }catch(e){
            commit('SET_TOKEN',null)
        }
    },
    async loadOneToOneOffers({commit, dispatch, rootGetters}) {
         try {
           let token = await dispatch('fetchToken');
          /* const epcl_id = '0d838d9f-16ea-4ed1-852e-c78f88287f7c';*/
             const epcl_id = rootGetters['ctUser/triangleID'];
           const {data} = await PersonalizationApi.GetOneToOneOffers(token, epcl_id,rootGetters.language)
             commit('APPLY_OFFERS', data.ctcOffers);
           }
         catch (e) {
            commit('APPLY_OFFERS', null);
        }
    },
}

const mutations = {
    APPLY_OFFERS(state, offers) {
        if(offers?.length){
            state.loadedOneToOneOffers = offers;
        } else {
            state.loadedOneToOneOffers = null;
        }
    },
    SET_TOKEN(state, token) {
        state.token = token
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};